import { Context, Dispatch, ReactNode, SetStateAction, useEffect, useMemo, useState } from 'react'
import { useLoaderData } from 'react-router'

interface LoaderContextProviderProps<T> {
    children: ReactNode | ((value: T) => ReactNode)
    context: Context<T>
    contextKey?: string
}

export function LoaderContextProvider<T>({ children, context }: LoaderContextProviderProps<T>) {
    const value = useLoaderData() as T
    return (
        <context.Provider value={value}>
            {
                typeof children === 'function' ? children(value) : children
            }
        </context.Provider>
    )
}

export function StatefulLoaderContextProvider<T>({ children, contextKey, context }: LoaderContextProviderProps<[T, Dispatch<SetStateAction<T>>]>) {
    const loader = useLoaderData() as T
    const [state, setState] = useState(loader)
    useEffect(() => {
        setState(loader)
    }, [loader])
    const value = useMemo<[T, Dispatch<SetStateAction<T>>]>(
        () => [state, setState],
        [state, loader],
    )
    return (
        <context.Provider key={contextKey} value={value}>
            {
                typeof children === 'function' ? children(value) : children
            }
        </context.Provider>
    )
}
